// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import './utils/fontSize' /** 设置字体大小 **/
import './assets/css/comment.css' /** 引入公共样式 **/
import './assets/css/iconfont.css'
import wx from 'weixin-js-sdk';
Vue.config.productionTip = false
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(Mint);


window.onload = function() {
  document.documentElement.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }, { passive: false});
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js